import { cleanObject } from '@shared/utils';
import { del, get, post, put } from '@/redux/requests/api.js';

export const getMembers = (callback) => {
  return get('/v1/pieve/members', {
    action: 'GET_MEMBERS',
    loader: 'getMembers',
    callback
  });
};

export const inviteMembers = ({ invites, signupSource } = {}, callback) => {
  return post('/v1/pieve/members', {
    action: 'INVITE_MEMBERS',
    loader: 'inviteMembers',
    callback,
    data: cleanObject(
      {
        invites,
        signupSource
      },
      { strict: true }
    )
  });
};

export const updateMember = ({ userId, roleId } = {}, callback) => {
  const normalizedUserId = String(userId || '').trim();

  return put(`/v1/pieve/members/${encodeURIComponent(normalizedUserId)}`, {
    action: 'UPDATE_MEMBER',
    loader: 'updateMember',
    callback,
    meta: {
      userId: normalizedUserId
    },
    data: cleanObject(
      {
        roleId
      },
      { strict: true }
    )
  });
};

export const resendMemberInvite = ({ userId } = {}, callback) => {
  const normalizedUserId = String(userId || '').trim();

  return post(`/v1/pieve/members/${encodeURIComponent(normalizedUserId)}/resend-invite`, {
    action: 'RESEND_MEMBER_INVITE',
    loader: 'resendMemberInvite',
    callback
  });
};

export const deleteMember = ({ userId } = {}, callback) => {
  const normalizedUserId = String(userId || '').trim();

  return del(`/v1/pieve/members/${encodeURIComponent(normalizedUserId)}`, {
    action: 'DELETE_MEMBER',
    loader: 'deleteMember',
    callback,
    meta: {
      userId: normalizedUserId
    }
  });
};
